import React from "react";
import { ListSelect } from "../../elements/list.select";
import { withTranslation, WithTranslation } from "react-i18next";
import { Tag } from "../../elements/tag";
import {SubscriptionPlansV3Array} from "../../../../common/data/subscription-plans";

interface Props extends WithTranslation {
  selected: string;
  onChange: (value: string) => void;
  plans: SubscriptionPlansV3Array[];
  isMainReseller: boolean;
}

interface State {
  period: "month" | "year";
}

export const SubscriptionPlansV4 = withTranslation()((props: Props) => {
  // const t = props.t;
  const { selected, onChange, plans, isMainReseller } = props;
  return (
    <div>
      <div className="flex-l-r-center m-b-4">
        <Tag className="">All prices in USD</Tag>
        <Tag className="">Plans can be modified or cancelled at any time</Tag>
      </div>
      <ListSelect
        selected={selected}
        onChange={(value) => onChange(value as string)}
        items={plans.map((plan, i) => ({
          value: plan.id,
          render: () => (
            <div className="width100 flex-line centered">
              <p className="small1" style={{ width: "100px" }}>{plan.name}</p>
              <div className="flex-l-r-center flex-grow">
                <p className="small1">{plan.price === "0" ? "FREE" : `$${plan.price}.00 per ${plan.period}`}</p>
                <p className="small1">{plan.description}</p>
              </div>
            </div>
          ),
        }))}
      />
      {isMainReseller && (
        <div className="text-center m-t-4">
          <p className="font-semi-bold">Choose the yearly plan and get 2 months free</p>
        </div>
      )}
    </div>
  );
});
